import { render, staticRenderFns } from "./approvalDetail.vue?vue&type=template&id=6fa1fa63&"
import script from "./approvalDetail.vue?vue&type=script&lang=js&"
export * from "./approvalDetail.vue?vue&type=script&lang=js&"
import style0 from "./approvalDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports